var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File_Outline",
    "data-name": "File Outline",
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(333 306)",
    fill: "#ffc051",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "File_Outline-2",
    "data-name": "File Outline",
    transform: "translate(278 310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M73.378,3.528,70.177.5A1.819,1.819,0,0,0,68.922,0h-6.1A1.828,1.828,0,0,0,61,1.826V15.174A1.828,1.828,0,0,0,62.826,17h9.3a1.828,1.828,0,0,0,1.826-1.826V4.855A1.834,1.834,0,0,0,73.378,3.528Zm-.967.456H69.932a.166.166,0,0,1-.166-.166V1.482ZM72.123,16h-9.3a.831.831,0,0,1-.83-.83V1.826a.831.831,0,0,1,.83-.83H68.77V3.818A1.163,1.163,0,0,0,69.932,4.98h3.021V15.174A.831.831,0,0,1,72.123,16Z",
    transform: "translate(0)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M135.8,200h-7.3a.5.5,0,0,0,0,1h7.3a.5.5,0,0,0,0-1Z",
    transform: "translate(-64.775 -193.359)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M135.8,280h-7.3a.5.5,0,0,0,0,1h7.3a.5.5,0,0,0,0-1Z",
    transform: "translate(-64.775 -270.703)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M130.913,360H128.5a.5.5,0,0,0,0,1h2.415a.5.5,0,0,0,0-1Z",
    transform: "translate(-64.775 -348.047)",
    fill: "#347af0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthEdit);
export default __webpack_public_path__ + "static/media/authEdit.50dbc9a3675d2a4f44c0b1c4f87f37eb.svg";
export { ForwardRef as ReactComponent };